import { render, staticRenderFns } from "./SecurityRoleItem.vue?vue&type=template&id=57ef7baa"
import script from "../../scripts/pages/SecurityRoleItem.js?vue&type=script&lang=js&external"
export * from "../../scripts/pages/SecurityRoleItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports